@if (visible$ | async) {
  <ng-content></ng-content>
}
